import styled from 'styled-components';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f9f9fa;
`;

export const ContentContainer = styled.div`
  height: 100%;
  padding-top: 8px;
`;

export const Content = styled.div`
  height: calc(100% - 8px);
  width: 100%;
  overflow-y: auto;

  @media ${DEVICE.MOBILE_PORTRAIT} {
    padding-bottom: 50px;
  }
`;
